// Import components
import SeoHead from '../components/seo/SeoHead';
import StickyNavbar from '../components/navbar/StickyNavbar';
import DeviceLinking from '../components/device/DeviceLinking';
import DisplayAd from '../components/ads/DisplayAd';
import Footer from '../components/landing/Footer';

export default function LinkDevicesPage() {
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex flex-col">
      <SeoHead route="/link-devices" />
      <StickyNavbar />

      <main className="flex flex-col flex-1 max-w-2xl mx-auto w-full py-20 md:py-24 px-4">
        <div className="flex flex-col items-center gap-8">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight mb-3">
              Link your devices with{' '}
              <span className="text-blue-600">WhenWeMeet?</span>
            </h1>
            <p className="text-gray-600 text-sm sm:text-lg max-w-xl">
              Sync meeting planners between your web browser and mobile app
              using a secure link code.
            </p>
          </div>

          {/* Device Linking Component */}
          <div className="w-full">
            <DeviceLinking />
          </div>
        </div>

        <div className="mx-auto mt-12">
          <DisplayAd />
        </div>
      </main>

      <Footer />
    </div>
  );
}
